import { createContext, use } from 'react'

/**
 * The label id of the enclosing DialogField when it has no `htmlFor`. Most
 * dialogs pass pickers without an id to point a <label for> at, so the label
 * named nothing; picker triggers read this and name themselves with
 * aria-labelledby — otherwise a screen reader announced "Select contact…"
 * with no field name.
 */
export const DialogFieldLabelContext = createContext<string | null>(null)

/**
 * `aria-labelledby` for a combobox trigger inside a DialogField: the field's
 * label, as a <label for> would give a native control. The current value is
 * announced as the combobox's value, not as part of its name.
 */
export function useDialogFieldLabelledBy(props: {
  'aria-label'?: string
  'aria-labelledby'?: string
}): string | undefined {
  const labelId = use(DialogFieldLabelContext)
  if (!labelId || props['aria-label'] || props['aria-labelledby'])
    return props['aria-labelledby']
  return labelId
}
